import { FieldType, Model, Schema } from "@core/index";
import { IContactAddress } from "./ContactAddress";
import { IFlightSegment } from "./FlightSegment";
import { ITraveler } from "./Traveler";

export enum Base { Origin, Destination };

export interface IAirportTransfer {
    id?: number;                    // Identity number (seed=1)
    flight?: IFlightSegment;        // Selected flight segment
    traveler?: ITraveler;           // Main traveler
    companions?: ITraveler[];       // Travelers who get in the car with the main traveler
    origin?: IContactAddress;       // origin address of trip 
    destination?: IContactAddress;  // destination address of trip
    pickupTime?: number;            // embarkation time in origin
    arrivalTime?: number;           // arrival time to destination
    serviceClassCode?: string;      // Vehicle type
    passengerCount?: number;        // Count of occupants
    baggageCount?: number;          // Count of baggages
    remarks?: string;               // User comments
}

export class AirportTransfer extends Model implements IAirportTransfer {
    public static schema: Schema = new Schema("AirportTransfer");
    public id?: number;
    public flight?: IFlightSegment;
    public traveler?: ITraveler;
    public companions?: ITraveler[];
    public origin?: IContactAddress;
    public destination?: IContactAddress;
    public pickupTime?: number;
    public arrivalTime?: number;
    public serviceClassCode?: string;
    public passengerCount?: number;
    public baggageCount?: number;
    public remarks?: string;

    constructor(values: IAirportTransfer) {
        super(AirportTransfer.schema);
        this.setValues(values);
    }
}

AirportTransfer.schema.addField("id").type(FieldType.Number);
AirportTransfer.schema.addField("flight").type(FieldType.Object);
AirportTransfer.schema.addField("traveler").type(FieldType.Object);
AirportTransfer.schema.addField("companions").type(FieldType.List);
AirportTransfer.schema.addField("origin").type(FieldType.Object).required();
AirportTransfer.schema.addField("destination").type(FieldType.Object).required();
AirportTransfer.schema.addField("pickupTime").type(FieldType.Number).required();
AirportTransfer.schema.addField("arrivalTime").type(FieldType.Number);
//AirportTransfer.schema.addField("serviceClassCode").type(FieldType.String).required();
AirportTransfer.schema.addField("baggageCount").type(FieldType.Number).required();
AirportTransfer.schema.addField("passengerCount").type(FieldType.Number);
AirportTransfer.schema.addField("remarks").type(FieldType.String);
AirportTransfer.schema.freeze();